export const loadImageFromBase64 = (base64) => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    if (!base64.startsWith('data:image')) {
      image.src = 'data:image/png;base64,' + base64;
    } else {
      image.src = base64;
    }

    image.onload = () => {
      resolve(image);
    };

    image.onerror = () => {
      reject(new Error('Cannot load image from base64'));
    };
  });
};
